module.exports = __webpack_public_path__ + "img/standing-users.567faf6a.svg";